import { useAffiliateData } from "@hooks/affiliates/affiliate/useAffiliateData";
import * as RootS from "../styles";
import * as S from "./styles";
import { format } from "@utils/utils";
import { useState } from "react";
import { OfferConstants } from "@@types/IOffer";
import { Tooltip } from "@kirvanobr/tooltip";
import { Typography } from "@kirvanobr/typography";
import { Button } from "@kirvanobr/button";

export default function OffersCard() {
  const { data } = useAffiliateData();
  const [isOffersOpen, setIsOffersOpen] = useState(false);
  const offers = data?.offers;
  const maxOfferCards = 3;

  const toggleShowMoreOffers = () => {
    setIsOffersOpen(!isOffersOpen);
  };

  const chargeFrequencyText = (chargeFrequency: string | undefined) => {
    switch (chargeFrequency) {
      case OfferConstants.ChargeFrequency.MONTHLY:
        return "Mensal | ";
      case OfferConstants.ChargeFrequency.ANNUALLY:
        return "Anual | ";
      default:
        return null;
    }
  };

  const chargeFrequencyLabel = (chargeFrequency: string | undefined) => {
    switch (chargeFrequency) {
      case OfferConstants.ChargeFrequency.MONTHLY:
        return " por mês";
      default:
        return null;
    }
  };

  if (!offers || !offers.length) return <></>;
  return (
    <RootS.ContentCard justifyContent="start" alignItems="start">
      <S.Header>
        <RootS.SubTitle dark margin="none">
          Ofertas
        </RootS.SubTitle>
        <S.Count>{offers.length}</S.Count>
        {offers.length > maxOfferCards && (
          <Button onClick={toggleShowMoreOffers} variant={"link"}>
            {isOffersOpen ? "Ver menos" : "Ver mais"}
          </Button>
        )}
      </S.Header>
      <S.Container>
        {offers.map((offer, index) => {
          const isFree = offer.isFree;
          const price = offer.promotionalPrice ? offer.promotionalPrice : offer.price;
          const finalPrice = isFree ? 0 : price;
          const commission = isFree ? 0 : offer.commission;
          const hasTooltip = offer.name.length > 15;
          const offerName = hasTooltip ? `${offer.name.slice(0, 15)}...` : offer.name;

          return (
            <S.OfferCard disabled={!isOffersOpen && index >= maxOfferCards} key={offer.name}>
              <S.ContentCardRow>
                <Tooltip
                  isDisabled={!hasTooltip}
                  content={<Typography size="t5">{offer.name}</Typography>}
                  placement="top-start"
                >
                  <RootS.Text bold dark>
                    {offerName}
                  </RootS.Text>
                </Tooltip>

                <RootS.Text bold dark small>
                  <S.Chargefrequency>{chargeFrequencyText(offer.chargeFrequency)}</S.Chargefrequency>
                  {format.money(finalPrice)}
                </RootS.Text>
              </S.ContentCardRow>
              <S.ContentCardRow>
                <RootS.Text light>
                  Você recebe
                  <RootS.Span bold blue spaced>
                    {format.money(commission)}
                  </RootS.Span>
                  {chargeFrequencyLabel(offer.chargeFrequency)}
                </RootS.Text>
              </S.ContentCardRow>
            </S.OfferCard>
          );
        })}
      </S.Container>
    </RootS.ContentCard>
  );
}
